import React from "react";
import { CircularProgress, Grid } from "@material-ui/core";
import useStyles from "./styles";

export default function TableDataSpinner() {
  const { container, spinner } = useStyles();
  return (
    <Grid item xs={12} container justify="center" className={container}>
      <CircularProgress className={spinner} />
    </Grid>
  );
}
